(function () {
  const templateId = 'sj-mobile-menu-template';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let attempts = 0;
  let applied = false;

  function findOriginalMenu() {
    const candidates = document.querySelectorAll(
      '.header__drawer .menu-drawer__menu, .menu-drawer__navigation .menu-drawer__menu, .menu-drawer .menu-drawer__menu'
    );

    return Array.from(candidates).find((menu) => {
      return !menu.classList.contains('sj-mobile-menu') && !menu.closest('.sj-mobile-menu');
    });
  }

  function patchMobileMenu() {
    if (applied || !mobileQuery.matches) return;

    const template = document.getElementById(templateId);
    if (!template || !template.content || !template.content.firstElementChild) return;

    const alreadyApplied = document.querySelector('.header__drawer .sj-mobile-menu, .menu-drawer .sj-mobile-menu');
    if (alreadyApplied) {
      applied = true;
      return;
    }

    const originalMenu = findOriginalMenu();
    if (!originalMenu) return;

    originalMenu.replaceWith(template.content.firstElementChild.cloneNode(true));
    applied = true;
  }

  function schedulePatch() {
    window.setTimeout(patchMobileMenu, 80);
  }

  function retryPatch() {
    patchMobileMenu();
    attempts += 1;
    if (!applied && attempts < 8) {
      window.setTimeout(retryPatch, 180);
    }
  }

  document.addEventListener('DOMContentLoaded', retryPatch);
  document.addEventListener('click', schedulePatch, true);
  window.addEventListener('resize', function () {
    if (!mobileQuery.matches) return;
    applied = false;
    attempts = 0;
    schedulePatch();
  });

  retryPatch();
})();
